/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PayrollViewerControllerGetCatalogs200ResponseDataCompaniesInner } from './payrollViewerControllerGetCatalogs200ResponseDataCompaniesInner';
import { PayrollViewerControllerGetCatalogs200ResponseDataEmployeesInner } from './payrollViewerControllerGetCatalogs200ResponseDataEmployeesInner';
import { PayrollViewerControllerGetCatalogs200ResponseDataSelf } from './payrollViewerControllerGetCatalogs200ResponseDataSelf';
import { PayrollViewerControllerGetCatalogs200ResponseDataPeriodsInner } from './payrollViewerControllerGetCatalogs200ResponseDataPeriodsInner';


export interface PayrollViewerControllerGetCatalogs200ResponseData { 
    mode?: PayrollViewerControllerGetCatalogs200ResponseData.ModeEnum;
    companies?: Array<PayrollViewerControllerGetCatalogs200ResponseDataCompaniesInner>;
    employees?: Array<PayrollViewerControllerGetCatalogs200ResponseDataEmployeesInner>;
    periods?: Array<PayrollViewerControllerGetCatalogs200ResponseDataPeriodsInner>;
    self?: PayrollViewerControllerGetCatalogs200ResponseDataSelf;
}
export namespace PayrollViewerControllerGetCatalogs200ResponseData {
    export type ModeEnum = 'selector' | 'self' | 'none';
    export const ModeEnum = {
        Selector: 'selector' as ModeEnum,
        Self: 'self' as ModeEnum,
        None: 'none' as ModeEnum
    };
}


